import { render } from "./Contact2.vue?vue&type=template&id=1fe3fec6&scoped=true"
import script from "./Contact2.vue?vue&type=script&lang=js"
export * from "./Contact2.vue?vue&type=script&lang=js"

import "./Contact2.vue?vue&type=style&index=0&id=1fe3fec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe3fec6"]])

export default __exports__